export default __webpack_public_path__ + "static/media/img_muslinTwoBunny_yg_p.83b71112.jpg";